export default {
    name: 'formpcompro',
    data () {
        return {
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        }
    },
    methods:{
    }
};


// WEBPACK FOOTER //
// ./src/components/form/formcompro.js